const $ = require('jquery');

// demo functionality that shows field description when field receives input
$('.booking [data-state="hidden"]').each(function () {
    let $slider = $(this).closest('.booking__steps'),
        $hiddenElem = $(this),
        $correspondingInput = $(this).closest('.field').find('.field__input');

    $correspondingInput.on('change', function () {
        $hiddenElem.attr('data-state', 'visible');
        $slider.trigger('refresh-slider');
    });
});

// demo functionality for updating next button in step 4
$('.booking input[name="add_examination"]').on('change', function () {
    let $booking = $(this).closest('.booking'),
        $step = $(this).closest('.booking__step'),
        $btnText = $step.find('.btn--booking-next .btn__text');

    if ($booking.find('input[name="add_examination"]:checked').val() == 1) {
        $btnText.attr('data-original-text', $btnText.text()).text('Doorgaan');
    } else {
        $btnText.text($btnText.attr('data-original-text'));
    }
});